import { TI_CUSTOM_ROLE_ID_RANGE, TI_ROLE_ID_RANGE, UserRole } from '@ti/contracts'

export const isAdminRole = (roleId: UserRole | number): boolean => {
  return (
    (roleId >= TI_ROLE_ID_RANGE[0] && roleId <= TI_ROLE_ID_RANGE[1]) ||
    (roleId >= TI_CUSTOM_ROLE_ID_RANGE[0] && roleId <= TI_CUSTOM_ROLE_ID_RANGE[1])
  )
}
